var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deliveryTable"},[_c('h2',{staticClass:"deliveryTable__title"},[_vm._v(_vm._s(_vm.data.Title))]),_vm._v(" "),_vm._l((_vm.tables),function(table,index){return [_c('SimpleTable',{key:index,staticClass:"deliveryTable__table",attrs:{"data":table,"variants":['borderless', 'firstColumnFixed']}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }